import { useId } from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

interface ReadonlySelectDropdownProps {
  label: string;
  value: string;
}

export const ReadonlySelectDropdown = ({ label, value }: ReadonlySelectDropdownProps) => {
  const id = useId();
  const labelId = `${id}-label`;

  return (
    <FormControl
      fullWidth
      disabled
    >
      <InputLabel
        id={labelId}
        shrink
      >
        {label}
      </InputLabel>
      <Select
        variant='outlined'
        label={label}
        labelId={labelId}
        value={value}
        disabled
        renderValue={() => value}
        tabIndex={-1}
        inputProps={{
          'aria-label': `${label}: ${value}`,
          tabIndex: -1,
        }}
      >
        <MenuItem value={value}>{value}</MenuItem>
      </Select>
    </FormControl>
  );
};
